import { AlphaJBoxOutlineIcon } from './AlphaJBoxOutlineIcon';

/**
 * author: Contributors
 * id 52E82BF4-8023-49C2-A4CB-AF3A88B43D1A
 * name alpha-j-box-outline
 * version: 3.2.89
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/alpha-j-box-outline.svg
 * tags
 * - Alpha / Numeric 
 */
export const AlphabetJBoxOutlineIcon = AlphaJBoxOutlineIcon;
export default AlphabetJBoxOutlineIcon